import styled from "styled-components";

export const Icon = styled.div`
    width: 16px;
    height: 16px;
    position: relative;
    overflow: hidden;
    cursor: pointer;
    transition: transform 0.15s ease, opacity 0.15s ease;

    &:active {
        transform: scale(0.85);
        opacity: 0.7;
    }

    img {
        width: 100%;
        height: 100%;
        display: block;
    }
`;

export const Container = styled.div`
    width: 100%;
    height: 170px;
    position: relative;

    &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 800px;
        height: 150.5px;
        opacity: 0.4;
        background: #f5f5f5;
        border-radius: 4px;
        border: 1px solid #d6d6d6;
        z-index: 0; /* keep background behind content */
    }

    /* ensure inner content sits above pseudo-element */
    > * {
        position: relative;
        z-index: 1;
    }
`;

export const Title = styled.div`
    position: absolute;
    top: 15.5px;
    left: 16.11px;
    color: #333;
    font-size: 16px;
    font-family: Roboto, sans-serif;
    font-weight: 700;
`;

export const EntityFieldWrapper = styled.div`
    position: absolute;
    top: 65.5px;
    left: 20px;
    width: 250px !important;
    max-width: 250px !important;
    height: auto;
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-right: 20px !important;
`;

export const EntityLabelRow = styled.div`
    display: inline-flex;
    justify-content: flex-start;
    align-items: center;
    gap: 8px;
    position: relative;
`;

export const EntityValueBox = styled.div`
    background: white;
    border-radius: 4px;
    outline: 1px solid #d6d6d6;
    outline-offset: -1px;
    display: inline-flex;
    justify-content: flex-start;
    align-items: center;
    gap: 8px;
    padding: 10px;
    height: 36px;
    width: 310px;
`;

export const ReturnFieldWrapper = styled.div`
    position: absolute;
    top: 65.5px;
    left: 350px;
    width: 520px;
    height: auto;
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

export const ReturnLabelRow = styled.div`
    display: inline-flex;
    justify-content: flex-start;
    align-items: center;
    gap: 8px;
    position: relative; /* for tooltip anchor */
`;

export const ReturnValueBox = styled.div`
    background: white;
    border-radius: 4px;
    outline: 1px solid #d6d6d6;
    outline-offset: -1px;
    display: inline-flex;
    justify-content: flex-start;
    align-items: center;
    gap: 8px;
    padding: 10px;
    height: 36px;
    width: 310px;
`;

export const ValueText = styled.span`
    flex: 1; /* take up all remaining space */
    min-width: 0; /* crucial for ellipsis in flexbox */
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const LabelText = styled.div`
    color: #333;
    font-size: 14px;
    font-family: Roboto, sans-serif;
    font-weight: 700;
    line-height: 16px;
`;

export const Tooltip = styled.div<{ visible: boolean }>`
    position: absolute;
    top: 50%;
    left: 60%;
    margin-left: 5px;
    transform: translateY(-50%);
    background: #333;
    color: white;
    font-size: 12px;
    padding: 3px 6px;
    border-radius: 4px;
    opacity: ${(props) => (props.visible ? 1 : 0)};
    transition: opacity 0.2s ease;
    pointer-events: none;
    white-space: nowrap;
`;
